import CallSplit from "@mui/icons-material/CallSplit";
import { styled } from "@mui/material";

import { makeSvgIcon } from "./svg-icon";

export const BranchIcon = styled(makeSvgIcon(CallSplit))({
  transform: "rotate(180deg)",
});

export default BranchIcon;
